import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 2 }
const _hoisted_2 = { key: 4 }
const _hoisted_3 = { key: 5 }

import { reactive, onMounted, computed, ref, unref } from 'vue'
import { useRouter } from 'vue-router'
import dayjs from 'dayjs'
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import UserSelect from '@/components/UserSelect/index'
import CosRangePicker from '@/components/CosRangePicker/index'
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard'
import { listByParamCodes } from '@/api/common'
import type { ParamCodeItem } from '@/typings/common'
import { downloadFileByBase64 } from '@/utils/index'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import { oaReviewStatus } from '@/views/overseasSales/commonEnum/dataConfig'
import { useI18n } from 'vue-i18n'
import { Modal as AModal } from 'ant-design-vue'
import {
  activityList,
  activityEnable,
  activityDisabled,
  activityDelete,
  partnerDropList,
  activityRetract
} from '@/api/marketing/marketingManage'
import Modal from '@/hooks/modalType'
import { ActivityCodeParams, ActivityCodeListItem } from '@/typings/api/marketingManage'
import { Item } from 'ant-design-vue/lib/menu'

const __default__ = { name: 'DcCosOFbuActivityCode' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const { clipboardRef, copiedRef } = useCopyToClipboard()
const { t } = useI18n()
const props = {
  subdomain: 'ofbu',
  paramCode: 'ofbu_source_channel'
}

const permission = {
  add: 'ofbu_activity_add_btn',
  edit: 'ofbu_activity_edit_btn',
  delete: 'ofbu_activity_del_btn',
  enable: 'ofbu_activity_enable_btn',
  disable: 'ofbu_activity_disable_btn',
  qrcode: 'ofbu_activity_qrcode_btn',
  add_not_approved: 'ofbu_activity_add_not_approved_btn',
  withdraw: 'ofbu_activity_withdraw_btn',
  submit: 'ofbu_activity_submit_btn'
}

const statusEnum = computed(() => [
  { name: t('marketing.可用'), value: 1, color: '#3FAC46' },
  { name: t('marketing.不可用'), value: 0, color: '#DF443B' }
])
const tableRef = ref()
const queryForm = reactive<ActivityCodeParams>({})

const columns = computed(() => [
  {
    title: t('marketing.活动名称'),
    dataIndex: 'activityName',
    cosType: 'link',
    path: `/${props.subdomain}/activityCode/view`,
    query: ['id'],
    fixed: 'left'
  },
  { title: t('marketing.来源渠道'), dataIndex: 'channelId' },
  { title: t('marketing.活动时间'), dataIndex: 'startTime' },
  {
    title: t('marketing.获客量'),
    dataIndex: 'salesCount',
    cosType: 'link',
    path: `/${props.subdomain}/salesClue`,
    query: ['channelExplain=$activityName', 'channelId=$channelId']
  },
  { title: t('marketing.活动负责人'), dataIndex: 'followerName' },
  { title: t('marketing.活动地点'), dataIndex: 'eventAddress' },
  { title: t('marketing.活动预算'), dataIndex: 'eventBudge' },
  { title: t('common.remark'), dataIndex: 'remark' },
  { title: t('marketing.活动状态'), dataIndex: 'enableFlag' },
  { title: t('business.wwys5u'), dataIndex: 'createTime', width: 190 },
  { title: t('custom.申请单号'), dataIndex: 'oaApplyNo' },
  { title: t('custom.当前审核人'), dataIndex: 'nextReviewer' },
  { title: t('operate.moulyj'), dataIndex: 'oaAuditStatus' },
  { title: t('marketing.审核意见'), dataIndex: 'oaReviewComments' },
  { title: t('common.action'), dataIndex: 'action', width: 170, fixed: 'right' }
])
const getList = (queryForm: ActivityCodeParams, callBack: (res: any) => void) => {
  activityList(queryForm).then((res) => {
    callBack(res)
  })
}

const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  [props.paramCode]: [] // 来源渠道
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [props.paramCode, 'ofbu_currency']
  }).then((res) => {
    paramCodeData.value = res.data
    console.log('paramCodeData:', paramCodeData.value)
  })
}
const partnerEnum = ref()
const getPartner = () => {
  partnerDropList().then((res) => {
    partnerEnum.value = res.data
  })
}
onMounted(() => {
  getByParamCodes()
  getPartner()
})

// 新增编辑函数
const triggerAddOrEdit = (id?: number, skipReview = 0, isSubmit = 0) => {
  if (id) {
    router.push({ path: `/${props.subdomain}/activityCode/edit`, query: { id, skipReview, isSubmit } })
  } else {
    router.push({ path: `/${props.subdomain}/activityCode/add`, query: { skipReview } })
  }
}
const handleStatus = (row: ActivityCodeListItem) => {
  const params = { activityQrcodeId: row.id }
  if (row.enableFlag) {
    activityDisabled(params).then(() => {
      message.success(t('marketing.市场活动已停用'))
      tableRef.value?.fetch()
    })
  } else {
    const isExpired = dayjs(row.endTime).valueOf() < dayjs().valueOf()
    if (!row.enableFlag && isExpired) return message.warning(t('marketing.活动已过期，无法启用'))
    activityEnable(params).then(() => {
      message.success(t('marketing.市场活动已启用'))
      tableRef.value?.fetch()
    })
  }
}
const handleDelete = (row: ActivityCodeListItem) => {
  Modal.delete({
    name: row.activityName,
    onOk() {
      activityDelete({ activityQrcodeId: row.id }).then(() => {
        message.success(t('marketing.删除市场活动成功'))
        tableRef.value?.delFetch()
      })
    }
  })
}

const handleWithdraw = (row: ActivityCodeListItem) => {
  AModal.warning({
    closable: true,
    title: t('marketing.是否撤回当前正在审核的流程？'),
    okCancel: true,
    cancelText: t('operate.jz7ejl'),
    okText: t('btn.confirm'),
    onOk() {
      activityRetract({ oaId: row.oaId }).then(() => {
        message.success(t('marketing.撤回活动成功'))
        tableRef.value?.fetch()
      })
    }
  })
}

const qrCodeRef = ref()
const qrCodeTitle = ref('')
const visible = ref<boolean>(false)
const currentRow = ref<ActivityCodeListItem>()
const qrCodeType = ref<'zh-CN' | 'en-US'>()
const qrCodeUrl = ref('')
const qrCodeLogoEnum = {
  fbu: require('@/assets/logo_gucang.png'),
  lbu: require('@/assets/logo_yuntu.png'),
  ofbu: require('@/assets/logo_ofbu.png')
}
const handleCopy = () => {
  clipboardRef.value = qrCodeUrl.value
  if (unref(copiedRef)) {
    message.success(t('marketing.市场活动链接复制成功'))
  } else {
    message.error(t('marketing.该浏览器不支持自动复制!'))
  }
}
const showModal = (lang: 'zh-CN' | 'en-US', row: any) => {
  const langEnum = { 'zh-CN': t('marketing.中文二维码'), 'en-US': t('marketing.英文二维码') }
  qrCodeType.value = lang
  qrCodeTitle.value = langEnum[lang]
  currentRow.value = row
  qrCodeUrl.value = `${window.WEB_URL}/mobile.html#/activity?qrcodeId=${row.id}&templateId=${row.activityTemplateId}&subdomain=${props.subdomain}&lang=${lang}`
  visible.value = true
}
const handleOk = () => {
  downloadFileByBase64(
    qrCodeRef.value.imgUrl,
    `${t('marketing.二维码')}-${currentRow.value?.activityName}-${qrCodeType.value}`
  )
  visible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            search: queryForm,
            "onUpdate:search": _cache[11] || (_cache[11] = ($event: any) => ((queryForm) = $event)),
            onFetch: getList,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: 'DcCosOFbuActivityCode'
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('clue.审核状态')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: queryForm.oaAuditStatus,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.oaAuditStatus) = $event)),
                        options: _unref(oaReviewStatus),
                        placeholder: _unref(t)('common.pleaseSelect'),
                        allowClear: "",
                        "show-arrow": ""
                      }, null, 8, ["value", "options", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "activityName",
                    label: _unref(t)('marketing.活动名称')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.activityName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.activityName) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "startTime",
                    label: _unref(t)('marketing.活动时间')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CosRangePicker), {
                        startTime: queryForm.startTime,
                        "onUpdate:startTime": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.startTime) = $event)),
                        endTime: queryForm.endTime,
                        "onUpdate:endTime": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.endTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "channelList",
                    label: _unref(t)('marketing.来源渠道')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ParamCodeCascader, {
                        type: "search",
                        ids: queryForm.channelList,
                        "onUpdate:ids": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.channelList) = $event)),
                        appId: "cos_ofbu",
                        options: paramCodeData.value[props.paramCode]
                      }, null, 8, ["ids", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "follower",
                    label: _unref(t)('marketing.活动负责人')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UserSelect), {
                        value: queryForm.follower,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.follower) = $event)),
                        placeholder: _unref(t)('common.pleaseSelect'),
                        allowClear: ""
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "enableFlag",
                    label: _unref(t)('operate.lbczwf')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        fieldNames: { label: 'name' },
                        value: queryForm.enableFlag,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.enableFlag) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseSelect'),
                        options: statusEnum.value
                      }, null, 8, ["value", "placeholder", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "createBy",
                    label: _unref(t)('common.createByName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UserSelect), {
                        value: queryForm.createBy,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.createBy) = $event)),
                        placeholder: _unref(t)('common.pleaseSelect'),
                        allowClear: ""
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.申请单号')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.oaApplyNo,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.oaApplyNo) = $event)),
                        maxlength: 100,
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'enableFlag')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    style: _normalizeStyle({color: statusEnum.value.find((item) => item.value === (text ? 1 : 0))?.color})
                  }, _toDisplayString(statusEnum.value.find((item) => item.value === (text ? 1 : 0))?.name || '--'), 5))
                : _createCommentVNode("", true),
              (column.dataIndex === 'oaAuditStatus')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    style: _normalizeStyle({color: _unref(oaReviewStatus).find((item) => item.value === text)?.color})
                  }, _toDisplayString(_unref(t)(_unref(oaReviewStatus).find((item) => item.value === text)?.lang || '--')), 5))
                : _createCommentVNode("", true),
              (column.dataIndex === 'eventBudge')
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(record.eventBudge
                  ? `${record.eventBudge}(${
                      paramCodeData.value.ofbu_currency.find((item) => item.id === record.eventBudgeCurrency)?.enName
                    })`
                  : '--'), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'channelId')
                ? (_openBlock(), _createBlock(ChannelText, {
                    key: 3,
                    appId: "cos_ofbu",
                    options: paramCodeData.value[props.paramCode],
                    value: text
                  }, null, 8, ["options", "value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'startTime')
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(dayjs)(record.startTime).format('YYYY/MM/DD')) + "-" + _toDisplayString(_unref(dayjs)(record.end).format('YYYY/MM/DD')), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'nextReviewer')
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(record.oaNextReviewer && record.oaNextReviewer.length > 0
                  ? record.oaNextReviewer.map((item) => item.employeeName || '--').join('、')
                  : '--'), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_MoreButton, { key: 6 }, {
                    default: _withCtx(() => [
                      (record.oaAuditStatus === '10' || record.oaAuditStatus === '11' || (record.oaAuditStatus === '30' && !record.oaApplyNo))
                        ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            type: "link",
                            onClick: ($event: any) => (triggerAddOrEdit(record.id, record.oaApplyNo || record.oaAuditStatus === '10' ? 0 : 1))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])), [
                            [_directive_permission, permission.edit]
                          ])
                        : _createCommentVNode("", true),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleDelete(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, permission.delete]
                      ]),
                      (record.oaAuditStatus === '10' || record.oaAuditStatus === '11')
                        ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                            key: 1,
                            type: "link",
                            onClick: ($event: any) => (triggerAddOrEdit(record.id, 0, 1))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('btn.提交')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])), [
                            [_directive_permission, permission.delete]
                          ])
                        : _createCommentVNode("", true),
                      (record.oaAuditStatus === '20')
                        ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                            key: 2,
                            type: "link",
                            onClick: ($event: any) => (handleWithdraw(record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('btn.revoke')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])), [
                            [_directive_permission, permission.withdraw]
                          ])
                        : _createCommentVNode("", true),
                      (!record.enableFlag && record.oaAuditStatus === '30')
                        ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                            key: 3,
                            type: "link",
                            onClick: ($event: any) => (handleStatus(record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('marketing.可用')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])), [
                            [_directive_permission, permission.enable]
                          ])
                        : (record.oaAuditStatus === '30')
                          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                              key: 4,
                              type: "link",
                              onClick: ($event: any) => (handleStatus(record))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('marketing.不可用')), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])), [
                              [_directive_permission, permission.disable]
                            ])
                          : _createCommentVNode("", true),
                      (record.oaAuditStatus === '30')
                        ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                            key: 5,
                            type: "link",
                            onClick: ($event: any) => (showModal('zh-CN', record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('marketing.中文二维码')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])), [
                            [_directive_permission, permission.qrcode]
                          ])
                        : _createCommentVNode("", true),
                      (record.oaAuditStatus === '30')
                        ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                            key: 6,
                            type: "link",
                            onClick: ($event: any) => (showModal('en-US', record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('marketing.英文二维码')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])), [
                            [_directive_permission, permission.qrcode]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (triggerAddOrEdit(undefined, 1)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('marketing.新增（不审核）')), 1)
                ]),
                _: 1
              })), [
                [_directive_permission, permission.add_not_approved]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (triggerAddOrEdit(undefined, 0)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.add')), 1)
                ]),
                _: 1
              })), [
                [_directive_permission, permission.add]
              ])
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(_unref(AModal), {
            visible: visible.value,
            "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((visible).value = $event)),
            title: qrCodeTitle.value,
            onOk: handleOk
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_a_button, {
                key: "submit",
                type: "primary",
                onClick: handleCopy
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('marketing.复制链接')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                key: "submit",
                type: "primary",
                onClick: handleOk
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('marketing.下载二维码')), 1)
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(vueQr, {
                margin: 0,
                size: 400,
                text: qrCodeUrl.value,
                logoSrc: qrCodeLogoEnum[props.subdomain],
                logoScale: 0.25,
                logoMargin: 6,
                correctLevel: 0,
                ref_key: "qrCodeRef",
                ref: qrCodeRef
              }, null, 8, ["text", "logoSrc"])
            ]),
            _: 1
          }, 8, ["visible", "title"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})